module.exports = __webpack_public_path__ + "static/media/power button.7b4a1aaf.svg";